import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

//  Services
import { AuthenticationService } from '../../services/authentication.service';
import { LookupService } from '../../services/lookup.service';
import { RegistrationService } from '../../services/registration.service';

@Component({
  selector: 'signup-component',
  templateUrl: './signup.component.html',
  providers: [],
})
export class SignUpComponent implements OnInit {
  username = '';
  password = '';
  confirmPassword = '';
  email = '';
  confirmEmail = '';

  salutations = [{"failed":false,"id":0,"name":""},{"failed":false,"id":1,"name":"Dr."},{"failed":false,"id":2,"name":"Miss"},{"failed":false,"id":3,"name":"Mr."},{"failed":false,"id":4,"name":"Mrs."},{"failed":false,"id":5,"name":"Ms."},{"failed":false,"id":6,"name":"Prof."}];
  salutation = 0;
  first = '';
  middle = '';
  last = '';
  suffixes = [{"failed":false,"id":0,"name":""},{"failed":false,"id":1,"name":"I"},{"failed":false,"id":2,"name":"II"},{"failed":false,"id":3,"name":"III"},{"failed":false,"id":4,"name":"Jr."},{"failed":false,"id":5,"name":"Sr."}];
  suffix = 0;

  countries = [];
  country = 0;

  errors = [];

  processing = false;

  constructor(
    private router: Router,
    private registrationService: RegistrationService,
    private authService: AuthenticationService,
    private lookupService: LookupService
  ) {}

  ngOnInit() {}

  signUp() {
    this.processing = true;
    this.registrationService
      .signUp({
        username: this.username,
        password: this.password,
        passwordConfirmation: this.confirmPassword,
        email: this.email,
        emailConfirmation: this.confirmEmail,
        salutation: this.salutation,
        first: this.first,
        middle: this.middle,
        last: this.last,
        suffix: this.suffix
      })
      .subscribe(
        (response) => {
          console.log('signUp response:', response);
          this.processing = false;
          if (response.created) {
            alert('Your account has been created.');
            this.router.navigate(['signin']);
          } else {
            this.errors = response.errors;
            if (this.errors === undefined) {
              this.errors = ['Unknown error, please try again later.'];
            }
          }
        },
        (err) => {
          console.log(err);
          this.processing = false;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/signup/signup.component.ts